import React from "react";
import {Button, Checkbox, Form, Icon, Input} from "antd";
import {Link} from "react-router-dom";
import AuthActions from "../appRedux/redux/Auth";
import MessageActions from "../appRedux/redux/Messages";
import {connect} from "react-redux";
import IntlMessages from "util/IntlMessages";
import {message} from "antd/lib/index";
import CircularProgress from "components/CircularProgress/index";
import { MAYOR_SCHEMA, UNIVERSAL_FIELDS } from "../schemas/user";

const FormItem = Form.Item;

class SignUpMayor extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      const finalValue = {
        ...MAYOR_SCHEMA,
        ...UNIVERSAL_FIELDS,
        ...values
      };
      if (!err) {
        this.props.showAuthLoader();
        this.props.userSignUp(finalValue);
      }
    });
  };

  constructor() {
    super();
    this.state = {
      email: 'demo@example.com',
      password: 'demo#123'
    }
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 100);
    }
    if (this.props.user != null) {
      this.props.history.push('/');
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {showMessage, loader, alertMessage} = this.props;
    return (
      <div className="gx-app-login-wrap gx-mt-15">
        <div className="gx-app-login-container">
          <div className="gx-app-login-main-content">
            <div className="gx-app-logo-content">
              <div className="gx-app-logo-content-bg">
                {/* <img src='https://via.placeholder.com/272x395' alt='Neature'/> */}
              </div>
              <div className="gx-app-logo-wid">
                <h1><IntlMessages id="app.userAuth.signUpMayor"/></h1>
                <p className="gx-mt-4"><IntlMessages id="app.userAuth.bySigning"/></p>
              </div>
              <div className="gx-app-logo">
                <Link to="/signup">
                  <button type="default" className="gx-btn gx-btn-red gx-text-white">
                    <IntlMessages id="app.userAuth.signUpClientButton"/>
                  </button>
                </Link>
              </div>
            </div>

            <div className="gx-app-login-content">
              <Form onSubmit={this.handleSubmit} className="gx-signup-form gx-form-row0">
                <FormItem>
                  {getFieldDecorator('name', {
                    rules: [{required: true, message: 'Por favor ingresa tu nombre completo!'}],
                  })(
                    <Input placeholder="Nombre completo"/>
                  )}
                </FormItem>

                <FormItem>
                  {getFieldDecorator('email', {
                    rules: [{
                      required: true, type: 'email', message: 'E-mail ingresado no válido!',
                    }],
                  })(
                    <Input placeholder="Correo electrónico"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('rif', {
                    rules: [{
                      required: true, message: 'Rif ingresado no válido!',
                    }],
                  })(
                    <Input placeholder="Rif"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('address', {
                    rules: [{
                      required: true, message: 'Direccion ingresada no válida!',
                    }],
                  })(
                    <Input placeholder="Dirección principal"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('officenumber', {
                    rules: [{
                      required: true, message: 'Número de contacto ingresada no válido!',
                    }],
                  })(
                    <Input type="number" placeholder="Número de contacto"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [{required: true, message: 'Por favor ingresa tu contraseña!'}],
                  })(
                    <Input type="password" placeholder="Contraseña"/>
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('remember', {
                    valuePropName: 'checked',
                    initialValue: true,
                  })(
                    <Checkbox><IntlMessages id="appModule.iAccept"/></Checkbox>
                  )}
                  <span className="gx-link gx-signup-form-forgot"><IntlMessages
                    id="appModule.termAndCondition"/></span>
                </FormItem>
                <FormItem>
                  <Button type="primary" className="gx-mb-0" htmlType="submit">
                    <IntlMessages id="app.userAuth.signUp"/>
                  </Button>
                  <span><IntlMessages id="app.userAuth.or"/></span> <Link to="/signin"><IntlMessages
                  id="app.userAuth.login"/></Link>
                </FormItem>
                {/* <div className="gx-flex-row gx-justify-content-between">
                  <span> ingresa con Google o Facebook</span>
                  <ul className="gx-social-link">
                    <li>
                      <Icon type="google" onClick={() => {
                        this.props.showAuthLoader();
                        this.props.userGoogleSignIn();
                      }}/>
                    </li>                 
                  </ul>
                </div> */}
              </Form>
            </div>
            {loader &&
            <div className="gx-loader-view">
              <CircularProgress/>
            </div>
            }
            {showMessage && this.props.isError && message.error(alertMessage)}
          </div>
        </div>
      </div>

    );
  }

}

const WrappedSignUpForm = Form.create()(SignUpMayor);

const mapStateToProps = ({auth, message: m, user: u}) => {
  const { loader } = auth;
  const { message, isError } = m;
  const { user } = u;
  return { loader, message, isError, user };
};

const mapActionsToProps = () => {
  const { 
    userSignUp,
    showAuthLoader,
    userSignInGoogle,
  } = AuthActions;
  const { hideMessage, showMessage } = MessageActions;
  return { userSignUp, showAuthLoader, userSignInGoogle, hideMessage, showMessage };
}

export default connect(mapStateToProps, mapActionsToProps())(WrappedSignUpForm);
